import { BillingDashboard } from '@components/dashboards/BillingDashboard';
import { EcoPageTitle } from '@components/shared/EcoPageTitle';
import EcoScrollView from '@components/views/EcoScrollView';
import React from 'react';
import { useGlobal } from '../hooks/useGlobal';
import { GlobalScreenProps } from '../navigation/types';

export default function BillingScreen({}: GlobalScreenProps): JSX.Element {
  const { session } = useGlobal();

  return (
    <EcoScrollView>
      <>
        <EcoPageTitle className="mb-5" title="Billing" subTitle="View and update your payment information" />
        {session?.merchantAdmin ? <BillingDashboard merchantAdmin={session.merchantAdmin} /> : null}
      </>
    </EcoScrollView>
  );
}
